import React, { Component, PureComponent } from 'react'
import { Route, Link } from 'react-router-dom'
import { Icon } from 'semantic-ui-react'

export function SubeditorListItem(props) {
  let {
    onClick,
    status,
    active = false,
    title,
    info = '',
    tag = false,
    tagColor = 'grey',
    tagIcon = false,
    to = false,
    exact = false,
  } = props

  return (
    <Route
      path={to}
      exact={exact}
      children={({ match }) => {
        let classes = ['subeditor-list-item']
        if (match) classes.push('subeditor-list-item--active')

        return (
          <Link to={to} className={classes.join(' ')}>
            <div className="subeditor-list-item-top">
              {status ? (
                <div className={`subeditor-list-item-status subeditor-list-item-status--${status}`}>
                  <span />
                </div>
              ) : null}
              <div className="subeditor-list-item-title">
                <span className="ellipsis">{title}</span>
              </div>
              {tag ? (
                <div className="subeditor-list-item-tag-wrapper">
                  <span className={`subeditor-list-item-tag subeditor-list-item-tag--${tagColor}`}>
                    {tagIcon ? <Icon name={tagIcon} /> : null} {tag}
                  </span>
                </div>
              ) : null}
            </div>
            <div className="subeditor-list-item-bottom">
              <div className="subeditor-list-item-info">{info}</div>
            </div>
          </Link>
        )
      }}
    />
  )
}

export function SubeditorArea({ title = false, buttons = false, children }) {
  return (
    <div className="subeditor-area">
      {title ? (
        <div className="subeditor-area-title">
          <div className="subeditor-area-title-text">{title}</div>
          {buttons ? <div className="subeditor-area-title-buttons">{buttons}</div> : null}
        </div>
      ) : (
        false
      )}
      <div className="subeditor-area-content">{children}</div>
    </div>
  )
}

export function SubeditorSideBox({ title = false, icon = false, children }) {
  return (
    <div className="subeditor-sidebox">
      {title ? (
        <div className="subeditor-sidebox-title">
          {icon ? (
            <div className="subeditor-sidebox-title-icon">
              <Icon name={icon} />
            </div>
          ) : null}
          <div className="subeditor-sidebox-title-text">
            <span className="ellipsis">{title}</span>
          </div>
        </div>
      ) : null}
      <div className="subeditor-sidebox-content">{children}</div>
    </div>
  )
}

export function SubeditorSplit({ columns = 2, children }) {
  return <div className={`subeditor-columns subeditor-columns--${columns}`}>{children}</div>
}

export function SubeditorBox({ children, fields = [] }) {
  if (!Array.isArray(fields)) fields = []

  return (
    <div className="subeditor-box">
      {fields.length ? (
        <div className="subeditor-box-fields">
          {fields.map(([label, value], key) => {
            return (
              <div className="subeditor-box-field" key={key}>
                <div className="subeditor-box-field-label">{label}</div>
                <div className="subeditor-box-field-value">{value}</div>
              </div>
            )
          })}
        </div>
      ) : null}
      {children}
    </div>
  )
}

export function SubeditorPerson({ children, name = '', fields = [], notes = false, editLocation = false }) {
  return (
    <div className="subeditor-person">
      <div className="subeditor-person-top">
        <div className="subeditor-person-fields">
          <div className="subeditor-person-name">
            <span>{name}</span>
          </div>
          {fields.map(([icon, value], key) => {
            if (!value) return null

            return (
              <div className="subeditor-person-field" key={key}>
                <div className="subeditor-person-field-label">
                  <Icon name={icon} />
                </div>
                <div className="subeditor-person-field-value">{value}</div>
              </div>
            )
          })}
        </div>
        {editLocation ? (
          <div className="subeditor-person-edit">
            <Link className="button-plain" to={editLocation}>
              Muokkaa
            </Link>
          </div>
        ) : null}
      </div>
      {notes ? (
        <div className="subeditor-person-notes">
          <p>{notes}</p>
        </div>
      ) : null}
      <div className="subeditor-person-children">{children}</div>
    </div>
  )
}
